import React from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { getDocchat, searchTickers } from "../apis/analysis-apis";
import { getUserInfo } from "../apis/user-apis";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import SearchableSelectBox from "../components/searchableSelectBox";
import PDFViewer from "../components/PDFViewer";
import ModalComponent from "../components/ModalComponent";
import HisotryDrawer from "../components/HisotryDrawer";
import TabsPdf from "../components/TabsPdf";
import SvgIcon from "@mui/material/SvgIcon";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TuneIcon from "@mui/icons-material/Tune";
import PhoneIcon from "@mui/icons-material/Phone";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import SummarizeIcon from "@mui/icons-material/Summarize";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Avatar from "@mui/material/Avatar";
import ChatIcon from "@mui/icons-material/Chat";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import darkTheme from "../theme/darkTheme";
import lightTheme from "../theme/lightTheme";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Pagination from "@mui/material/Pagination";

import { notification } from "antd";

import { defualtErrorMessage } from "../common/common-variables";
import { phdSearchFormater } from "../common/common-helper-functions";
import SelectBox from "../components/select-box";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import {
  highlightPlugin,
  RenderHighlightTargetProps,
  Trigger,
} from "@react-pdf-viewer/highlight";

import { searchPlugin } from "@react-pdf-viewer/search";

import PreLoader from "../components/loader";
import FinchatTopicModal from "../components/finchat-topics-modal";

const inputDarkTheme = {
  paper: {
    p: "2px 4px",
    display: "flex",
    alignItems: "center",
    //   width: 400,
    background: "#333", // Adjust background color
    marginTop: "1rem",
  },
  textArea: {
    ml: 1,
    flex: 1,
    color: "#ccc", // Adjust text color
    maxHeight: "200px",
    height: "52px",
    overflowY: "hidden",
  },
  inputBase: {
    ml: 1,
    flex: 1,
    color: "#ccc", // Adjust text color
  },
  iconButton: {
    p: "10px",
    color: "#ccc", // Adjust icon color
  },
};

const chatDarkTheme = {
  chatContainer: {
    maxWidth: "600px",
    margin: "auto",
    background: "#333",
    padding: "16px",
    borderRadius: "8px",
    color: "#ccc",
  },
  questionContainer: {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
  },
  userAvatar: {
    marginRight: "8px",
    backgroundColor: "#555",
  },
  answerContainer: {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    background: "#1f2937",
  },
  chatbotIcon: {
    marginRight: "8px",
    color: "green",
  },
};

const tabsDarkTheme = {
  tabs: {
    background: "#333", // Adjust background color for the entire Tabs component
  },
  tab: {
    color: "#ccc", // Adjust text color for the Tab component
    width: "100%",
    "&.Mui-selected": {
      color: "orange", // Adjust text color for the selected tab
      borderBottom: "2px solid orange", // Add a bottom border for the selected tab
    },
  },
  icon: {
    color: "#ccc", // Adjust icon color
    "&.Mui-selected": {
      color: "orange", // Adjust text color for the selected tab icon
    },
  },
  indicator: {
    position: "absolute",
    height: "2px",
    bottom: 0,
    width: "100%",
    transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "orange", // Adjust the indicator color to orange
  },
};

const defaltSelectedTicker = [
  {
    label: "Vodafone Idea Limited - IDEA - Common Stock - NSE - India",
    value: "Vodafone Idea Limited - IDEA - Common Stock - NSE - India",
  },
];

const summaryTypeOptions = [
  {
    label: "Short",
    value: "short",
  },
  {
    label: "Summary By Topic",
    value: "summary_by_topic",
  },
  {
    label: "Summary By Extracting Topic",
    value: "summary_by_extracting_topics",
  },
];

const FinChat = () => {
  const [tickersOptions, setTickersOptions] = useState([]);
  const [selectedTickers, setSelectedTickers] = useState(defaltSelectedTicker);
  const [selectedTab, setSelectedTab] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [questionInput, setQuestionInput] = useState("");
  const [chatList, setChatList] = useState([]);
  const [selectedSummaryType, setSelectedSummaryType] = useState(
    summaryTypeOptions[0]
  );
  const [chatSummary, setChatSummary] = useState({});
  const [chatSummaries, setChatSummaries] = useState({});
  const [documentChunks, setDocumentChunks] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [isPDFLoading, setPDFLoading] = useState(false);
  const [selectedRef, setSelectedRef] = useState(1);
  const [keywords, setKeywords] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState({});
  const [pdfList, setPdfList] = useState([]);
  // const [selectedSummary, setSelectedSummary] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  // const [availableDocuments, setAvailableDocuments] = useState({});
  const [docTypeGroupedDocuments, setDocTypeGroupedDocuments] = useState({});
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  // topics related states
  const [showTopicModal, setShowTopicModal] = useState(false);
  const [userEnteredTopics, setUserEnteredTopics] = useState([]);
  const [fetchInitialData, setFetchInitialData] = useState(false);

  const location = useLocation();

  const sessionStoredStates = {
    finchat_tickersOptions: setTickersOptions,
    finchat_selectedTickers: setSelectedTickers,
    finchat_chatList: setChatList,
    finchat_chatSummary: setChatSummary,
    finchat_chatSummaries: setChatSummaries,
    finchat_keywords: setKeywords,
    finchat_selectedPdf: setSelectedPdf,
    finchat_pdfList: setPdfList,
    finchat_docTypeGroupedDocuments: setDocTypeGroupedDocuments,
    finchat_selectedDocuments: setSelectedDocuments,
  };

  const searchPluginInstance = searchPlugin({
    keyword: keywords,
  });

  const { highlight } = searchPluginInstance;

  const highlightPluginInstance = highlightPlugin({
    trigger: Trigger.None,
  });

  // fetching User Info.
  useEffect(() => {
    getUserInfo()
      .then((resp) => {
        setUserInfo(resp.data);
      })
      .catch((err) => {});
  }, []);

  // fetching the documents for the selected tickers.
  useEffect(() => {
    const pdfList = sessionStorage.getItem("finchat_pdfList");

    if (selectedTickers?.length) {
      setPDFLoading(true);
      setIsSummaryLoading(true);
      const queryStirng = {};
      const codes = [];
      for (let ticker of selectedTickers) {
        //console.log("ticker:", defaltSelectedTicker);
        let code = ticker.value.split(" - ")[1].trim();
        //console.log("code", code);
        codes.push(code);
      }
      queryStirng["logic_function"] = "get_document_metadata_from_db"; //"get_document_metadata_from_db"; //get_document_from_db"
      queryStirng["codes"] = codes;

      getDocchat(queryStirng)
        .then((resp) => {
          let responseData = resp.data;
          if (typeof responseData === "string") {
            responseData = JSON.parse(responseData);
          }
          responseData = resp.data.result;
          let yearlyGroupeData = resp.data.yearly_grouped_data || {};
          let docTypeGrouped = resp.data.doc_type_grouped || {};
          const sorteyearlyGroupeData = {};
          if (Object.keys(yearlyGroupeData).length) {
            const sortedKeys = Object.keys(yearlyGroupeData).sort(
              (a, b) => b - a
            );
            //console.log("sortedKeys", sortedKeys)
            sortedKeys.forEach((key) => {
              //console.log("key", key)
              sorteyearlyGroupeData[`${key}:`] = yearlyGroupeData[key];
              //console.log("sorteyearlyGroupeData", sorteyearlyGroupeData)
            });
          }

          //console.log("this is the response", responseData);
          //console.log("this is the yearlyGroupeData", sorteyearlyGroupeData);
          setDocumentChunks(responseData);
          if (responseData?.length) {
            const newPdf = {
              code: responseData[0].code,
              title: `${responseData[0]?.doc_type}-${new Date(
                0,
                responseData[0]?.month
              ).toLocaleString("default", { month: "short" })}-${
                responseData[0]?.year
              }`,
              pdfLink: responseData[0].s3_url,
              doc_id: responseData[0].doc_id,
            };
            let newPdfs = responseData.map((item) => ({
              code: item.code,
              title: `${item.doc_type}-${new Date(
                0,
                item?.month
              ).toLocaleString("default", { month: "short" })}-${item.year}`,
              pdfLink: item.s3_url,
              doc_id: item.doc_id,
            }));
            const selectedDocs = [];
            for (let doc of responseData) {
              //  adding selected documents
              if (doc?.is_selected === 1) {
                selectedDocs.push(doc.doc_id);
              }
            }
            //console.log("selectedDocs", selectedDocs)
            //console.log("newPdfs", newPdfs)
            // setAvailableDocuments(sorteyearlyGroupeData)
            setDocTypeGroupedDocuments(docTypeGrouped);
            saveStateToSessionStorage({
              state: docTypeGrouped,
              key: "finchat_docTypeGroupedDocuments",
            });
            setSelectedDocuments(selectedDocs);
            saveStateToSessionStorage({
              state: selectedDocs,
              key: "finchat_selectedDocuments",
            });
            setSelectedPdf(newPdf);
            saveStateToSessionStorage({
              state: newPdf,
              key: "finchat_selectedPdf",
            });

            // check before adding
            setPdfList((prev) => {
              // Check if the PDF already exists based on its id
              const pdfExists = prev.some(
                (pdf) => pdf.doc_id === newPdf.doc_id
              );

              // If the PDF doesn't exist, add it to the state array
              if (!pdfExists) {
                saveStateToSessionStorage({
                  state: [...prev, ...newPdfs],
                  key: "finchat_pdfList",
                });
                return [...prev, ...newPdfs];
              }

              // If the PDF exists, return the previous state without adding a new item
              return prev;
            });
          } else {
            // setSelectedPdf(prev => prev)
            notification.error({
              message: "Sorry",
              description: `We don't have any documents for ${selectedTickers[0].value
                .split(" - ")[1]
                .trim()}`,
              placement: "bottomRight",
            });
          }

          setPDFLoading(false);
        })
        .catch((err) => {
          //console.log("this is the errror", err);
        });
    }
  }, [selectedTickers]);

  // fetching the summary for the selected ticker documets.
  useEffect(() => {
    //console.log("selectedPdf", selectedPdf)
    //console.log("chatSummaries.hasOwnProperty(selectedPdf.doc_id)", chatSummaries.hasOwnProperty(selectedPdf.doc_id))
    //console.log("chatSummaries[selectedPdf.doc_id].hasOwnProperty(selectedSummaryType.value", chatSummaries[selectedPdf.doc_id]?.hasOwnProperty(selectedSummaryType.value))

    // checking if summary is already present in chatSummaries
    if (selectedSummaryType.value !== "summary_by_topic") {
      if (chatSummaries.hasOwnProperty(selectedPdf.doc_id)) {
        //console.log("inside first if")
        if (
          chatSummaries[selectedPdf.doc_id]?.hasOwnProperty(
            selectedSummaryType.value
          )
        ) {
          //console.log("inside second if")
          setChatSummary(chatSummaries[selectedPdf.doc_id]);
          setIsSummaryLoading(false);
          return;
        }
      }
    }

    if (Object.keys(selectedPdf).length) {
      if (selectedTickers?.length) {
        setIsSummaryLoading(true);
        const queryStirngSummarisation = {};
        queryStirngSummarisation["logic_function"] = "summarisation";
        queryStirngSummarisation["codes"] = selectedPdf.code;
        queryStirngSummarisation["summary_type"] = selectedSummaryType?.value
          ? selectedSummaryType.value
          : "short";
        if (selectedSummaryType.value === "summary_by_topic") {
          const selectedTopics = userEnteredTopics.map((item) => item.text);
          //console.log("selectedTopics", selectedTopics)
          queryStirngSummarisation["topics"] = selectedTopics;
        }
        queryStirngSummarisation["doc_ids"] = [selectedPdf.doc_id];
        getDocchat(queryStirngSummarisation)
          .then((resp) => {
            let responseData = resp.data;
            if (typeof responseData === "string") {
              responseData = JSON.parse(responseData);
            }
            if (responseData?.params?.summary_type === "summary_by_extracting_topics") {
              responseData.summary = JSON.parse(responseData.summary);
            }
            const doc_id = responseData?.params?.doc_ids?.[0];
            const code = responseData?.params?.codes?.[0];

            if (chatSummaries.hasOwnProperty(selectedPdf.doc_id)) {
              setChatSummaries((prev) => {
                let updatedChatSummaries = {
                  ...prev,
                  [selectedPdf.doc_id]: {
                    ...prev[selectedPdf.doc_id],
                    [responseData?.params?.summary_type]: {
                      summary_text:
                        responseData?.summary || responseData?.summaries,
                      type: responseData?.summary
                        ? typeof responseData?.summary
                        : typeof responseData?.summaries,
                    },
                  },
                };

                saveStateToSessionStorage({
                  state: updatedChatSummaries,
                  key: "finchat_chatSummaries",
                });

                return updatedChatSummaries;
              });

              setChatSummary({
                ...chatSummaries[selectedPdf?.doc_id],
                [responseData?.params?.summary_type]: {
                  summary_text:
                    responseData?.summary || responseData?.summaries,
                  type: responseData?.summary
                    ? typeof responseData?.summary
                    : typeof responseData?.summaries,
                },
              });
            } else {
              setChatSummaries((prev) => {
                const updatedChatSummaries = {
                  ...prev,
                  [selectedPdf.doc_id]: {
                    doc_id: selectedPdf?.doc_id,
                    code: selectedPdf?.code, // Assuming code is from selectedPdf
                    [responseData?.params?.summary_type]: {
                      summary_text:
                        responseData?.summary || responseData?.summaries,
                      type: responseData?.summary
                        ? typeof responseData?.summary
                        : typeof responseData?.summaries,
                    },
                  },
                };
                saveStateToSessionStorage({
                  state: updatedChatSummaries,
                  key: "finchat_chatSummaries",
                });
                return updatedChatSummaries;
              });

              setChatSummary({
                doc_id: selectedPdf?.doc_id,
                code: selectedPdf?.code, // Assuming code is from selectedPdf
                [responseData?.params?.summary_type]: {
                  summary_text:
                    responseData?.summary || responseData?.summaries,
                  type: responseData?.summary
                    ? typeof responseData?.summary
                    : typeof responseData?.summaries,
                },
              });
            }

            setIsSummaryLoading(false);
          })
          .catch((err) => {
            //console.log("this is the errror", err);
          });
      }
    }
  }, [selectedSummaryType, selectedDocuments, selectedPdf]);

  useEffect(() => {
    // loading the stored states from sessions

    //console.log("loadStateFromSessionStorage")
    // loadStateFromSessionStorage()

    // const handleBeforeUnload = async (event) => {
    //   // Prevent the default unload behavior
    //   // Not all browsers support this anymore, but it can trigger a confirmation dialog in some cases
    //   event.preventDefault();

    //   //console.log("Saving state to the session...");

    //   // sending state to session

    //   event.returnValue = '';
    // };

    // window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      //console.log("clean-up logic before unmount")
      // window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const saveStateToSessionStorage = ({ state = {}, key = "finchat" }) => {
    try {
      const serializedState = JSON.stringify(state);
      sessionStorage.setItem(key, serializedState);
    } catch (error) {
      // console.error("Could not save state", error);
    }
  };

  const loadStateFromSessionStorage = () => {
    for (const sessionStoredState in sessionStoredStates) {
      //console.log("sessionStoredState", sessionStoredState)
      try {
        const serializedState = sessionStorage.getItem(sessionStoredState);
        //console.log(`serializedState for ${sessionStoredState}`, serializedState)
        if (serializedState) {
          const parsedserializedState = JSON.parse(serializedState);
          //console.log(`parsedserializedState for ${sessionStoredState}`, parsedserializedState)
          sessionStoredStates[sessionStoredState](parsedserializedState);
        }
      } catch (error) {
        // console.error("Could not load state", error);
      }
    }
    setFetchInitialData(true);
  };

  useEffect(() => {
    if (keywords?.length > selectedRef) {
      const result = highlight(keywords[selectedRef]);
      //console.log("result", result)
      if (result) {
        //console.log("JSON.stringify()", JSON.stringify(result))
      } else {
        notification.error({
          message: "Error",
          description: defualtErrorMessage,
          placement: "bottomRight",
        });
      }
    } else {
      // notification.error({
      //   message: "Error",
      //   description: defualtErrorMessage,
      //   placement: "bottomRight",
      // })
    }
  }, [keywords]);

  const handleChangeTab = (event, newValue) => {
    //console.log("new value", newValue);
    setSelectedTab(newValue);
  };

  const handleIconClick = () => {
    // Your click event logic goes here
    ////console.log("Icon clicked!");
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleButtonClick = () => {
    setIsChatLoading(true);
    // Add your logic or actions to be performed on button click
    const queryStirng = {};
    const codes = [];
    for (let ticker of selectedTickers) {
      //console.log("ticker:", defaltSelectedTicker);
      let code = ticker.value.split(" - ")[1].trim();
      //console.log("code", code);
      codes.push(code);
    }

    // only selecting the documents ids of current selected ticker
    const filteredDocIds = pdfList
      .filter(
        (pdf) => selectedDocuments.includes(pdf.doc_id) && pdf.code === codes[0]
      )
      .map((pdf) => pdf.doc_id);

    queryStirng["logic_function"] = "question_answering";
    queryStirng["codes"] = codes;
    queryStirng["question"] = questionInput;
    queryStirng["doc_ids"] = filteredDocIds;

    getDocchat(queryStirng)
      .then((resp) => {
        let responseData = resp.data;
        if (typeof responseData === "string") {
          responseData = JSON.parse(responseData);
        }
        //console.log("this is the response", responseData);
        //console.log("this is the typeof response", typeof responseData);

        let docChunks = [];
        let extractedElements = [];
        let pdf = null;
        let intDocIds = responseData.params?.doc_ids?.map((id) =>
          parseInt(id, 10)
        );

        if (
          responseData.answer.includes("Answer not available in context") ||
          responseData.answer.includes("unable to answer")
        ) {
          docChunks = [];
          extractedElements = [];
          pdf = null;
        } else {
          docChunks = responseData.chunks?.slice(0, 3) || [];
          //console.log("docChunks****\n", docChunks)
          extractedElements = docChunks.map((docChunk) =>
            phdSearchFormater(docChunk.chunk)
          );
          //console.log("extractedElements", extractedElements)
          pdf = pdfList.find((pdf) => pdf.doc_id === intDocIds?.[0]);
        }

        setChatList((prev) => {
          const newChat = {
            question: responseData?.question,
            answer: responseData?.answer,
            chunks: docChunks,
            keywords: extractedElements,
            selectedPdf: pdf,
            selectedRef: 1,
            id: prev.length + 1,
            doc_ids: intDocIds,
            codes: responseData.params?.codes,
          };

          saveStateToSessionStorage({
            state: [...chatList, newChat],
            key: "finchat_chatList",
          });

          return [...chatList, newChat];
        });
        setQuestionInput("");
        setKeywords(extractedElements);
        saveStateToSessionStorage({
          state: extractedElements,
          key: "finchat_keywords",
        });
        setIsChatLoading(false);
      })
      .catch((err) => {
        //console.log("this is the errror", err);
        notification.error({
          message: "Error",
          description: err.response?.data?.message || defualtErrorMessage,
          placement: "bottomRight",
        });
        setIsChatLoading(false);
      });
  };

  const handleTickerSearchInput = (inputValue, callback) => {
    // Handle changes in the search input
    //console.log("inputValue", inputValue);
    const queryStirng = {};
    queryStirng["primary_metric"] = inputValue;
    searchTickers(queryStirng)
      .then((resp) => {
        //console.log("this is the response for searchTickers", resp);
        let tickersOptions = resp.data.data;

        setTickersOptions(tickersOptions);
        saveStateToSessionStorage({
          state: tickersOptions,
          key: "finchat_tickersOptions",
        });
        callback(tickersOptions);
      })
      .catch((err) => {
        ////console.log("this is the errror");
      });
  };

  const handleQuestionInputChange = (event) => {
    // Update the state with the new input value
    ////console.log(
    //   "this is the user input event.target.value",
    //   event.target.value
    // );
    setQuestionInput(event.target.value);

    // Additional logic you want to perform on input change
  };

  const handleChangeRef = (message) => (event, value) => {
    //console.log("Selected page number:", value);
    //console.log("Pagination message:", message);

    // finding the index of that element
    let chat = chatList.find((element) => element.id === message.id);
    //console.log("chat", chat)

    // updating the chatlist selectedRef for that given chat

    setChatList((currentArray) => {
      const updatedChatlist = currentArray.map((item) =>
        item?.id === message.id ? { ...item, selectedRef: value } : item
      );

      saveStateToSessionStorage({
        state: updatedChatlist,
        key: "finchat_chatList",
      });

      return updatedChatlist;
    });

    // setting the reference for that question
    setSelectedRef(value);
    // setting the keywords and pdfurl of that specific url
    setKeywords(chat.keywords);
    saveStateToSessionStorage({
      state: chat.keywords,
      key: "finchat_keywords",
    });

    // showing those documnets in pdf right hand side tabs
    setSelectedDocuments((prev) => {
      let newDocs = [];
      for (const doc_id of chat?.doc_ids) {
        if (!prev.includes(doc_id)) {
          newDocs.push(doc_id);
        }
      }
      saveStateToSessionStorage({
        state: [...prev, ...newDocs],
        key: "finchat_selectedDocuments",
      });
      return [...prev, ...newDocs];
    });

    // setting the pdf showing the  url
    setSelectedPdf(chat.selectedPdf);
    saveStateToSessionStorage({
      state: chat.selectedPdf,
      key: "finchat_selectedPdf",
    });
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleSelectTicker = (selectedOptions) => {
    //console.log("adding the selected option to the state", selectedOptions);
    setSelectedTickers([selectedOptions]);
    saveStateToSessionStorage({
      state: selectedOptions,
      key: "finchat_selectedTickers",
    });
  };

  const scrollToKeyword = (keywordIndex) => {
    //console.log("inside scrollToKeyword", keywordIndex)
    //console.log("inside keywords", keywords)

    if (keywords?.length > keywordIndex) {
      const result = highlight(keywords[keywordIndex]);
      //console.log("result", result)
      if (result) {
        //console.log("JSON.stringify()", JSON.stringify(result))
        // // Scroll to the destination
        // result.pageNumber !== null && result.pageNumber !== undefined &&
        //   result.pageNumber >= 0 &&
        //   result.pageNumber < result.doc.numPages &&
        //   result.doc.setPage(result.pageNumber + 1);
        // result.destArray !== null && result.destArray !== undefined &&
        //   result.destArray.length > 0 &&
        //   jumpToDestination(result.destArray[0]);
      } else {
        notification.error({
          message: "Error",
          description: defualtErrorMessage,
          placement: "bottomRight",
        });
      }
    } else {
      notification.error({
        message: "Error",
        description: defualtErrorMessage,
        placement: "bottomRight",
      });
    }
    // const { jumpToDestination } = searchPluginInstance;
    // const keyword = keywords[keywordIndex];
    // const result = jumpToDestination(keyword);
    // if (result) {
    //   // Scroll to the destination
    //   result.pageNumber !== null && result.pageNumber !== undefined &&
    //     result.pageNumber >= 0 &&
    //     result.pageNumber < result.doc.numPages &&
    //     result.doc.setPage(result.pageNumber + 1);
    //   result.destArray !== null && result.destArray !== undefined &&
    //     result.destArray.length > 0 &&
    //     jumpToDestination(result.destArray[0]);
    // }
  };

  const handleChangePdfTab = (event, newValue) => {
    //console.log("this is the new selectedPdf", newValue)
    const clickedPdf = pdfList.find((pdf) => pdf.pdfLink === newValue);
    // const pdfSummary = chatSummaryList.find(pdf => pdf.code === clickedPdf.id);

    setSelectedPdf(clickedPdf);
    saveStateToSessionStorage({
      state: clickedPdf,
      key: "finchat_selectedPdf",
    });

    // setChatSummary(pdfSummary);
  };

  const removePdf = (pdf, event) => {
    setSelectedDocuments((prevDocuments) => {
      // removing the clicked document from selected documents array
      
      const filteredDocIds = pdfList
        .filter(
          (ipdf) =>
            prevDocuments.includes(ipdf.doc_id) &&
            ipdf.code === selectedTickers[0].value.split(" - ")[1].trim()
        )
        .map((ipdf) => ipdf.doc_id);


      if (filteredDocIds.length === 1 && filteredDocIds.includes(pdf.doc_id)) {
        notification.error({
          message:
            "At Least One Document of selected ticker Must Remain Selected",
          placement: "bottomRight",
        });
        return prevDocuments;
      }

      const filteredArray = prevDocuments.filter((item) => item !== pdf.doc_id);
      
      if (selectedPdf.doc_id === pdf.doc_id) {
        // displaying the 1st selected document incase user removes the selected pdf document.
        const newSelectedpdf = pdfList.find(
          (pdf) => pdf.doc_id === filteredArray[0]
          );
        setSelectedPdf(newSelectedpdf);
        saveStateToSessionStorage({
          state: filteredArray[0],
          key: "finchat_selectedPdf",
        });
      }

      saveStateToSessionStorage({
        state: filteredArray,
        key: "finchat_selectedDocuments",
      });
      return filteredArray;
    });
  };

  const handleSelectDocument = (selectedDocument, event) => {
    setSelectedDocuments((prevDocuments) => {
      // Check if the document is already selected
      const exists = prevDocuments.includes(selectedDocument.doc_id);

      // if the document is already selected
      if (exists) {
        if (prevDocuments.length === 1) {
          notification.error({
            message: "At Least One Document Must Remain Selected",
            placement: "bottomRight",
          });
          return prevDocuments;
        } else {
          const filteredArray = prevDocuments.filter(
            (item) => item !== selectedDocument.doc_id
          );

          saveStateToSessionStorage({
            state: filteredArray,
            key: "finchat_selectedDocuments",
          });

          const newSelectedpdf = pdfList.find(
            (pdf) => pdf.doc_id === filteredArray[0]
          );

          setSelectedPdf(newSelectedpdf);

          saveStateToSessionStorage({
            state: filteredArray[0],
            key: "finchat_selectedPdf",
          });
          return filteredArray;
        }
      } else {
        saveStateToSessionStorage({
          state: [...prevDocuments, selectedDocument.doc_id],
          key: "finchat_selectedDocuments",
        });
        return [...prevDocuments, selectedDocument.doc_id];
      }
    });
  };

  const handleChangeSummaryType = (selectedOptions) => {
    //console.log("INsiede handleChangeSummaryType", selectedOptions)
    if (selectedOptions.value === "summary_by_topic") {
      setShowTopicModal(true);
    } else {
      setSelectedSummaryType(selectedOptions);
    }
  };

  const handleClickAddTopics = (event) => {
    // showing the add/edit topic modal
    setShowTopicModal(true);
  };

  const hideTopicModal = (event) => {
    // showing the add/edit topic modal
    setShowTopicModal(false);
  };

  const handleDeleteTopic = (i) => {
    setUserEnteredTopics(userEnteredTopics.filter((tag, index) => index !== i));
  };

  const handleAdditionTopic = (tag) => {
    setUserEnteredTopics([...userEnteredTopics, tag]);
  };

  const handleDragTopic = (tag, currPos, newPos) => {
    const newUserEnteredTopics = userEnteredTopics.slice();

    newUserEnteredTopics.splice(currPos, 1);
    newUserEnteredTopics.splice(newPos, 0, tag);

    // re-render
    setUserEnteredTopics(newUserEnteredTopics);
  };

  const handleTagClickTopic = (index) => {
    //console.log('The tag at index ' + index + ' was clicked');
    setShowTopicModal(false);
  };

  const handleClicksubmitTopics = (e) => {
    // hide modal
    setShowTopicModal(false);
    //
    setSelectedSummaryType({
      label: "Summary By Topic",
      value: "summary_by_topic",
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      // Prevent the default action to avoid form submission or any other default behavior
      event.preventDefault();
      if (questionInput?.trim()) {
        handleButtonClick();
      }
    }
  };

  return (
    <Box
      sx={{
        height: "95vh",
        backgroundColor: darkTheme.palette.background.default,
        overflow: "hidden",
      }}
    >
      <ModalComponent
        open={isModalOpen}
        handleClose={handleCloseModal}
        // availableDocuments = {availableDocuments}
        docTypeGroupedDocuments={docTypeGroupedDocuments}
        selectedDocuments={selectedDocuments}
        handleSelectDocument={handleSelectDocument}
        selectedTickers={selectedTickers}
      />

      <FinchatTopicModal
        open={showTopicModal}
        handleClose={hideTopicModal}
        topics={userEnteredTopics}
        handleAddition={handleAdditionTopic}
        handleDelete={handleDeleteTopic}
        handleDrag={handleDragTopic}
        handleTagClick={handleTagClickTopic}
        handleClicksubmitTopics={handleClicksubmitTopics}
      />
      <Grid container spacing={0} sx={{ height: "100%" }}>
        <Grid
          item
          xs={6}
          sx={{
            borderRight: "1px solid rgba(218, 224, 231, 0.08)",
            paddingRight: "10px",
            height: "95vh",
            // position: "relative",
          }}
        >
          <SearchableSelectBox
            selectedTickers={selectedTickers}
            isMulti={false}
            handleInputChange={handleTickerSearchInput}
            handleSelectChange={handleSelectTicker}
            defaltPrimaryMetric={defaltSelectedTicker}
          />

          <Grid item sx={{ margin: "1rem" }}>
            <Grid container spacing={6}>
              <Grid
                item
                onClick={handleIconClick}
                style={{ cursor: "pointer" }}
              >
                <Tooltip title="Select Documents" placement="right-start" arrow>
                  <>
                    Documents{" "}
                    <TuneIcon className="hoverable-icon" iconposition="end" />
                  </>
                </Tooltip>
              </Grid>
              {/* <Grid item>
                <HisotryDrawer />
              </Grid>
              <Grid item>
                <TuneIcon className="hoverable-icon" />
              </Grid>
              <Grid item>
                <TuneIcon />
              </Grid>
              <Grid item>
                <TuneIcon />
              </Grid> */}
            </Grid>
          </Grid>
          <Tabs
            value={selectedTab}
            onChange={handleChangeTab}
            aria-label="icon label tabs example"
            sx={tabsDarkTheme.tabs}
            classes={{ flexContainer: "customFlexContainer" }} // Override the flexContainer class
          >
            <Tab
              icon={
                <SummarizeIcon
                  sx={tabsDarkTheme.icon}
                  style={{ verticalAlign: "middle" }}
                  iconposition="end"
                />
              }
              label="Summary"
              sx={tabsDarkTheme.tab}
              value={0}
            />
            <Tab
              icon={
                <QuestionAnswerIcon
                  sx={tabsDarkTheme.icon}
                  style={{ verticalAlign: "middle" }}
                  iconposition="end"
                />
              }
              label="Q&A"
              sx={tabsDarkTheme.tab}
              value={1}
            />
          </Tabs>

          {/* <Grid item sx={{ margin: "1rem" }}></Grid> */}

          <div
            style={
              selectedTab
                ? { height: "calc(100% - 240px)", overflow: "auto" }
                : {}
            }
          >
            <>
              {selectedTab ? (
                <>
                  {chatList.map((message, index) => (
                    <div key={`index${message.id}`} className="mt-1">
                      <div style={chatDarkTheme.questionContainer}>
                        {userInfo?.avtar ? (
                          <img
                            className="dropdown-toggle profile-dropdown-img"
                            src={userInfo.avtar}
                            alt="User profile"
                          />
                        ) : (
                          <i className="bi bi-person-circle finchat-user fa-2x"></i>
                        )}

                        <Box sx={{ ml: 1 }}>
                          <div>You</div>
                          <div>{`${message.question}`}</div>
                        </Box>
                      </div>

                      <div
                        style={chatDarkTheme.answerContainer}
                        className="mt-1"
                      >
                        <Avatar style={chatDarkTheme.chatbotIcon}>
                          <ChatIcon />
                        </Avatar>
                        <div>
                          {/* <div>Chatbot</div> */}
                          <div>{`${message?.answer}`}</div>
                          {message?.chunks?.length ? (
                            <Box
                              id="ref-pagination"
                              sx={{
                                marginTop: "5px",
                                color: "orange",
                                display: "flex",
                                alignItems: "center",
                                float: "right",
                              }}
                            >
                              <Box sx={{ color: "green", display: "inline" }}>
                                {" "}
                                References :{" "}
                              </Box>
                              <Pagination
                                count={message?.chunks?.length}
                                page={message.selectedRef}
                                onChange={handleChangeRef(message)}
                              />
                            </Box>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                  {isChatLoading && (
                    <div className="chat-loader-container">
                      {" "}
                      <PreLoader />{" "}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Box sx={{ textAlign: "center" }}>
                    <SelectBox
                      options={summaryTypeOptions}
                      defaultValue={selectedSummaryType}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={false}
                      isSearchable={false}
                      handleSelectChange={handleChangeSummaryType}
                      isMulti={false}
                      label={"Summary Type"}
                      className={"selectbox-container"}
                    />

                    {selectedSummaryType?.value === "summary_by_topic" ? (
                      <Box sx={{ mt: 1 }}>
                        <Tooltip
                          placement="right-start"
                          arrow
                          title={"Add Topics"}
                        >
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={handleClickAddTopics}
                          >
                            Add topics
                            <AddCircleIcon
                              iconposition="end"
                              sx={{ color: "#fff" }}
                            />
                          </span>
                        </Tooltip>
                      </Box>
                    ) : null}
                  </Box>

                  {isSummaryLoading ? (
                    <div className="loader-container">
                      {" "}
                      <PreLoader />{" "}
                    </div>
                  ) : (
                    <Box sx={{ p: "1rem" }}>
                      <Box
                        sx={{
                          textAlign: "center",
                          fontSize: "1.2rem",
                          color: "orange",
                        }}
                      >
                        {" "}
                        {chatSummary?.code}{" "}
                      </Box>
                      {chatSummary?.[selectedSummaryType?.value]?.["type"] ===
                      "object" ? (
                        <Box
                          sx={{
                            marginTop: "1rem",
                            overflow: "auto",
                            maxHeight: "50vh",
                          }}
                        >
                          {Object.keys(
                            chatSummary?.[selectedSummaryType?.value]?.[
                              "summary_text"
                            ] || {}
                          )?.map((topic) => (
                            <Box key={topic}>
                              <Box
                                sx={{
                                  color: "orange",
                                  marginBottom: "3px",
                                  fontSize: "large",
                                }}
                              >
                                {" "}
                                {topic}:{" "}
                              </Box>
                              <Box sx={{ mb: 1 }}>
                                {" "}
                                {
                                  chatSummary?.[selectedSummaryType?.value]?.[
                                    "summary_text"
                                  ]?.[topic]
                                }{" "}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            marginTop: "1rem",
                            overflow: "auto",
                            maxHeight: "50vh",
                          }}
                        >
                          {chatSummary?.[selectedSummaryType?.value]?.[
                            "summary_text"
                          ]
                            ? chatSummary[selectedSummaryType.value][
                                "summary_text"
                              ]
                            : defualtErrorMessage}{" "}
                        </Box>
                      )}
                    </Box>
                  )}
                </>
              )}
            </>

            {selectedTab ? (
              <Box
                sx={{
                  // display: "flex",
                  // position: "relative",
                  // width:' 50%',
                  // bottom: '-50px'
                  position: "absolute",
                  bottom: "-55px",
                  width: "50%",
                }}
              >
                <Paper
                  component="div"
                  sx={{
                    // position: "absolute",
                    // bottom: 0,
                    // left: 0,
                    width: "90%",
                    margin: "1rem",
                    ...inputDarkTheme.paper,
                  }}
                >
                  <InputBase
                    placeholder="Type your question"
                    sx={inputDarkTheme.inputBase}
                    onChange={handleQuestionInputChange}
                    onKeyDown={handleKeyPress}
                    value={questionInput}
                  />
                  <Tooltip
                    title="Submit question"
                    placement="right-start"
                    arrow
                  >
                    <IconButton
                      type="button"
                      sx={inputDarkTheme.iconButton}
                      aria-label="search"
                      onClick={handleButtonClick}
                      tabIndex={0} // Ensure the component is focusable
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>
                </Paper>
              </Box>
            ) : null}
          </div>
        </Grid>

        <Grid
          item
          xs={6}
          sx={{ paddingLeft: "10px", display: "flex", flexDirection: "column" }}
        >
          {pdfList?.length ? (
            <Box sx={{ padding: "1rem" }}>
              <TabsPdf
                pdfList={pdfList}
                selectedDocuments={selectedDocuments}
                selectedPdf={selectedPdf}
                handleChangePdfTab={handleChangePdfTab}
                removePdf={removePdf}
              />
            </Box>
          ) : null}

          {isPDFLoading ? (
            <div className="loader-container pdf-loader">
              {" "}
              <PreLoader wrapperClass="pdf-loader" />{" "}
            </div>
          ) : (
            <>
              {selectedPdf?.doc_id && (
                <div>
                  <PDFViewer
                    selectedPdf={selectedPdf}
                    keywords={keywords}
                    scrollToKeyword={scrollToKeyword}
                    highlight={highlight}
                    highlightPluginInstance={highlightPluginInstance}
                    searchPluginInstance={searchPluginInstance}
                  />
                </div>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
export default FinChat;
